<template>
  <div id="DatePickerComponent" class="position-relative">
    <div class="pickerImg">
      <img v-show="!pickerModal" src="/assets/images/datePicker.svg">
      <img v-show="pickerModal" src="/assets/images/datepickerActive.svg">
    </div>
    <div class="pickerData">
      <h5 :class="{'error-message-color': !isValid}">{{datepickerTranslation}}</h5>
      <p>{{displayDate}}</p>
    </div>
    <Datepicker
        class="dp__menu"
        id="picker"
        ref="datepicker"
        position="center"
        monthNameFormat="long"
        autoApply

        :minDate="new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)"
        :closeOnAutoApply="true"
        :enableTimePicker="false"
        :locale="store.state.general.locale"

        v-model="date"
        @update:modelValue="changeDate"
        @open="opened"
        @closed="closed"
    >
      <template #clear-icon="{clear}">
      </template>
    </Datepicker>
    <template v-if="!isValid">
      <MessageComponent :message-class="'error-date-message'" :message="message"></MessageComponent>
    </template>
  </div>
</template>

<script>
import './DatePickerComponent.scss';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/src/VueDatePicker/style/main.scss';
import MessageComponent from "../message/MessageComponent.vue";
import {useStore} from "vuex";
import {dateHelpers} from "../../helpers/dateHelpers";

export default {
  components: { Datepicker, MessageComponent },
  props: {
    datepickerTranslation: {
      type: String,
      required: true,
    },
    pickupDate: {
      type: Boolean,
      required: false
    },
    dateStore: {
      type: Date,
      default: null
    },
    defaultDate: {
      type: Date
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String
    }
  },

  setup() {
    const store = useStore();

    return {
      store
    }
  },

  data() {
    return {
      date: null,
      displayDate: '',
      pickerModal: false,
    };
  },

  watch: {
    dateStore: {
      handler(newVal, oldVal) {
        this.date = newVal;
        if (this.date === null) {
          // this.date = this.defaultDate;
          this.date = this.dateStore;
        }

        this.changeDate(this.date);
      },
    }
  },

  methods: {
    opened: function () {
      this.pickerModal = true;
    },
    closed: function () {
      this.pickerModal = false;
    },
    changeDate: function (modelData) {
      if (modelData === null) {
        modelData = this.dateStore;
      }
      this.displayDate = dateHelpers.dateToDisplay(modelData);
      this.$emit('getDate', {value: modelData, pickup: this.pickupDate});
    },
  },

  created() {
    if (this.dateStore) {
      this.date = this.dateStore;
      this.displayDate = dateHelpers.dateToDisplay(this.dateStore);
    } else {
      this.date = this.defaultDate;
      this.displayDate = dateHelpers.dateToDisplay(this.defaultDate);
      this.$emit('getDate', {value: this.defaultDate, pickup: this.pickupDate});
    }
  }
}
</script>

<style lang="scss">
@import "../../../sass/variables";

.dp__menu {
  border-radius: 16px;
  padding: 0.2rem;
}

.dp__date_hover_end:hover,
.dp__date_hover_start:hover,
.dp__date_hover:hover {
  background-color: $grey-lighter;
  border-radius: 50%;
}

.dp__today {
  border-radius: 50%;
  border: 1px solid $blue;
}

.dp__active_date {
  background-color: $blue;
  border-radius: 50%;
}

.dp__overlay_cell_active {
  background: $blue;
}
.dp__cell_disabled {
  background-color: rgba(0, 41, 255, 0.03);
  //border: 0.5px solid #0029FF;
}

.dp__calendar_item {
  padding: 0.2rem;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
}

.dp__arrow_top,
.dp__arrow_bottom,
.dp__arrow_left,
.dp__arrow_right {
  display: none;
}

div.dp__calendar_header_separator {
  display: none;
}
.dp__calendar_header {
  color: $grey;
  width: 100%;
}

.dp__month_year_row {
  justify-content: center;
}

.dp__month_year_select:nth-child(2) {
  //justify-content: end;
  width: 30%;
  //margin-right: 0.2rem;
}
.dp__month_year_select:nth-child(3) {
  //justify-content: start;
  width: 30%;
  //margin-left: 0.2rem;
}

.dp__month_year_select {
  font-weight: 700;
}

.dp__month_year_col_nav {
  width: 40%;
}

.dp__month_year_col_nav:nth-child(1) {

}
.dp__month_year_col_nav:nth-child(4) {
  display: flex;
  //width: 100%;
  justify-content: flex-end;
}

</style>
